module.exports = __webpack_public_path__ + "img/x_letter_w.5a4bbbb2.svg";